export default __webpack_public_path__ + "static/media/pokedex5.a0b528e2.jpg";